/**
 * next-auth's logger. One case is quieted: in development, a session cookie this server cannot
 * decrypt (JWT_SESSION_ERROR) is a warning line, not an error.
 *
 * Every local dev server shares one `localhost` cookie jar across ports, and the servers set
 * different NEXTAUTH_SECRETs, so signing in on one leaves a cookie the next cannot read. next-auth
 * already treats that as signed out (and `getServerSession` catches it), but it logs an error,
 * which Next's dev overlay shows as "1 Issue" on every sign-in page. In production the same error
 * can mean a rotated secret, so it stays an error there. Every other code is logged as before.
 */

import type { LoggerInstance } from 'next-auth';

export const authLogger: Partial<LoggerInstance> = {
    error(code, metadata) {
        if (code === 'JWT_SESSION_ERROR' && process.env.NODE_ENV === 'development') {
            console.warn(
                '[next-auth] a session cookie this server cannot read was ignored (signed out); ' +
                    'it was set by another local server or an old NEXTAUTH_SECRET',
            );
            return;
        }
        console.error(`[next-auth][error][${code}]`, metadata);
    },
};
